import { createContext, useContext } from 'react';

/* Who is signed in. null when sign-in is switched off (demo / local development without Entra settings). */
export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);
